import type { ValuePropositionItem } from './types';

export const valuePropositionTitle =
	'PilarHomes: o maior portfólio atualizado de imóveis de alto padrão';

export const valuePropositionItems: ValuePropositionItem[] = [
	{
		id: 'leadership',
		title: 'Liderança no alto padrão',
		description: 'Mais de R$ 4,5 bilhões negociados nos últimos 12 meses.'
	},
	{
		id: 'service',
		title: 'Atendimento sob medida',
		description:
			'Conexão direta com corretores especialistas nos melhores endereços.'
	},
	{
		id: 'portfolio',
		title: 'Imóveis exclusivos',
		description: 'Mais opções e imóveis que você só encontra aqui.'
	}
];

export const PAGINATION_DELAY_MS = 6000;
export const PAGINATION_AUTOPLAY = false;
